import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-solution2',
  templateUrl: './solution2.component.html',
  styleUrls: ['./solution2.component.scss']
})
export class Solution2Component implements OnInit {
  constructor(private readonly seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'MUF-K.Integrated Claims Lifecycle Platform | DotBlack',
      description: 'Coordinate insurers and service providers across the claims lifecycle with centralised communication, workflow and operational visibility.',
      path: '/digital-solutions/',
      type: 'product',
      schema: { '@context': 'https://schema.org', '@type': 'Product', name: 'MUF-K.Integrated', brand: { '@type': 'Brand', name: 'DotBlack' }, url: 'https://dotblack.co.za/digital-solutions/', description: 'Coordinate insurers and service providers across the claims lifecycle with centralised communication, workflow and operational visibility.' }
    });
  }
}
